import { type IConfig } from '@cian/config/shared';

export const getIsSoldFurnishedLabelText = (config: IConfig) => {
  return config.get<string>('labels.isSoldFurnished') || 'С мебелью';
};
